import { Component, Vue } from 'vue-property-decorator'
import CAJG1050Service from './CAJG1050Service'
import CAJG1050ViewModel from './CAJG1050ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import '@/assets/css/colorbox.css'
import CommonConstants from '@/common/CommonConstants'
import TransportService from '@/common/TransportService'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent } from '@/assets/js/main.js'
import ColorBox from '@/assets/js/components/colorbox.js'

@Component({
  name: 'CAJG1050',
  components: {}
  })
export default class CAJG1050Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private cajg1050ViewModel: CAJG1050ViewModel = {
    studyMovieHtmlInfo: {
      content: ''
    }
  }

  private cajg1050Service: CAJG1050Service = new CAJG1050Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$nextTick(() => {
      ColorBox()
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const [caja1050ResponseModel] = await Promise.all([
      this.cajg1050Service.callAPICAJA1050(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CAJG1050, null, null)
    ])
    if (CommonUtil.isNotEmpty(caja1050ResponseModel.studyMovieHtmlInfo)) {
      this.cajg1050ViewModel.studyMovieHtmlInfo.content =
        CommonUtil.replacePathCMS(
          caja1050ResponseModel.studyMovieHtmlInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1050ResponseModel.studyMovieHtmlInfo.path
        )
    } else {
      this.cajg1050ViewModel.studyMovieHtmlInfo = null
    }
  }

  /**
   * 学習メニュートップ（ログイン後）(CAJG1060 )画面に遷移する。
   */
  private gotoCAJG1060() {
    this.$router.push({ name: 'cajg1060' })
  }
}
